import Modal from "react-modal";
import { X } from "phosphor-react";


const AreaOfInterestModal = ({
  
  closeInterestsModal,
  interests,
  inputValues,
  handleInterestSelection,
  interestsModalIsOpen,
  customStyles,
}) => {
  return (
    <Modal
      isOpen={interestsModalIsOpen}
      onRequestClose={() => closeInterestsModal()}
      style={customStyles}
      className="vessel-modal"
    >
      <div className="mt-[150px] bg-white rounded-xl p-5 m-4 max-w-[600px] lg:p-[30px]">
        <div className="flex justify-between items-center pb-4 border-b">
          <h3 className="text-lg font-semibold">Areas of Interest</h3>
          <div className="" onClick={() => closeInterestsModal()}>
            <X
              weight="bold"
              className="text-base font-semibold cursor-pointer"
            />
          </div>
        </div>

        <p className="text-sm text-gray-600 mt-4 mb-6">
          Select up to 3 areas that interest you most (
          {inputValues.interests.length}/3 selected)
        </p>

        <div className="grid grid-cols-1 gap-3 max-h-[400px] overflow-y-auto">
          {interests.map((interest, index) => {
            const isSelected = inputValues.interests.includes(interest);
            const isDisabled = !isSelected && inputValues.interests.length >= 3;

            return (
              <div
                key={index}
                className={`flex items-center p-3 border rounded-lg cursor-pointer transition-all ${
                  isSelected
                    ? "border-green-500 bg-green-50"
                    : isDisabled
                    ? "border-gray-200 bg-gray-50 opacity-50 cursor-not-allowed"
                    : "border-gray-200 hover:border-gray-300"
                }`}
                onClick={() => !isDisabled && handleInterestSelection(interest)}
              >
                <div
                  className={`w-5 h-5 border-2 rounded flex items-center justify-center mr-3 ${
                    isSelected
                      ? "border-green-500 bg-green-500"
                      : "border-gray-300"
                  }`}
                >
                  {isSelected && (
                    <svg
                      className="w-3 h-3 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </div>
                <span
                  className={`text-sm ${
                    isDisabled ? "text-gray-400" : "text-gray-700"
                  }`}
                >
                  {interest}
                </span>
              </div>
            );
          })}
        </div>

        <div className="flex gap-3 mt-6 pt-4 border-t">
          <button
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            onClick={() => closeInterestsModal()}
          >
            Cancel
          </button>
          <button
            className="flex-1 px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 disabled:opacity-50"
            onClick={() => closeInterestsModal()}
            disabled={inputValues.interests.length === 0}
          >
            Done ({inputValues.interests.length})
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AreaOfInterestModal;
